import { calcDailyCalories } from "./calcCalories";
import { calcMinCalories } from "./calcMinCalories";

const KCAL_PER_KG = 7700;
const MAX_DAILY_DEFICIT = 1000;

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function calcSprintDeficit(sprint) {
  if (!sprint) return 0;

  const low = (sprint.extraLowMin || 0) * 4;
  const high = (sprint.extraHighMin || 0) * 8;

  return (low + high) / 7;
}

export function calcTargetCalories(profile, weight, sprint, timeSpan) {
  console.log("calcTargetCalories");
  if (!profile || !weight || !profile.targetWeight || !profile.timeSpan) {
    return null;
  }

  const maintenance = calcDailyCalories(profile, weight);
  if (!maintenance) return null;

  const weightDiff = weight - profile.targetWeight;

  const totalCaloriesNeeded = weightDiff * KCAL_PER_KG;

  let dailyDeficit = totalCaloriesNeeded / profile.timeSpan;

  dailyDeficit = clamp(dailyDeficit, -MAX_DAILY_DEFICIT, MAX_DAILY_DEFICIT);

  const sprintDeficit = calcSprintDeficit(sprint);

  const minCalories = calcMinCalories(profile, maintenance);

  let targetCalories = maintenance - dailyDeficit - sprintDeficit;

  targetCalories = Math.max(minCalories, targetCalories);

  console.log(targetCalories);

  return Math.round(targetCalories);
}